export default __webpack_public_path__ + "static/media/imageC3.2ad01209.png";